import { i18n } from '@/plugins/i18n';

const productCategories: string[] = [
  'animal',
  'vegetable',
  'foodstuffs',
  'chemicals',
  'plastics',
  'animal-products',
  'textiles',
  'feather-products',
  'stone',
  'metal',
  'machinery',
  'electronics',
  'vehicles'
];

function categoriesOptions(): { label: string; sub: string; value: string | null }[] {
  const categories = productCategories.map((val: string) => {
    return {
      label: i18n.t(`products.category-select.${val}`).toString(),
      sub: i18n.t(`products.category-select.${val}-sub`).toString(),
      value: val || null
    };
  });
  categories.unshift({
    label: i18n.t('products.category-select.unspecified').toString(),
    sub: '',
    value: null
  });
  return categories;
}

export { categoriesOptions };
